/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { notificationsAPI } from 'src/api/modules/notifications';
import notice from 'src/common/components/Notice';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Badge } from '@material-ui/core';
import { formatDate } from 'src/utils/dates';
import Dropdown from 'react-bootstrap/Dropdown';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { DropdownTopbarItemToggler } from '../dropdowns';
import { sessionsAPI } from 'src/api/modules/sessions';
import { useHistory } from 'react-router-dom';
import { useClickOutside } from 'src/hooks/useClickOutside';

const Notifications = () => {
	const selectRef = useRef(null);
	const history = useHistory();
	const [notifications, setNotifications] = useState([]);
	const [showNoti, setShowNoti] = React.useState(false);
	const [numberN, setNumberN] = useState();
	useClickOutside(setShowNoti, selectRef);

	useEffect(() => {
		getNotifications();
	}, []);

	const getNotifications = () => {
		notificationsAPI
			.getNotifications()
			.then((r) => {
				setNumberN(r.length);
				setNotifications(r);
				setTimeout(() => {
					getNotifications();
				}, 2.7e6);
			})
			.catch((e) => notice('Ocurrio un error al obtener las notificaciones'));
	};

	const approvalNotification = (data, approval) => {
		sessionsAPI
			.removalApproval(data.idSesion, approval)
			.then((response) => {
				getNotifications();
				if (response.codigo === 'SAOC-400' || response.codigo === 'SAOC: 500')
					notice(JSON.parse(JSON.stringify(response.mensaje)));
			})
			.catch((e) => {
				if (e?.response?.data?.mensaje === undefined)
					notice('Ocurrio un error con su petición');
				else notice(JSON.parse(JSON.stringify(e?.response?.data?.mensaje)));
			});
	};

	return (
		<Dropdown
			drop="down"
			onClick={() => {
				setShowNoti(!showNoti);
			}}
			show={showNoti}
			ref={selectRef}
		>
			<Dropdown.Toggle
				as={DropdownTopbarItemToggler}
				id="dropdown-toggle-user-profile"
			>
				<div className="d-flex">
					<IconButton onClick={() => {}} color="secondary" aria-label="delete">
						<Badge badgeContent={numberN} color="primary">
							<NotificationsIcon />
						</Badge>
					</IconButton>
				</div>
			</Dropdown.Toggle>
			<Dropdown.Menu
				style={{
					boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 20px',
				}}
				className={
					notifications?.length > 2
						? 'dropdown-menu-xl p-5 pre-scrollable'
						: 'dropdown-menu-xl p-5'
				}
			>
				<h5
					style={{
						textAlign: 'center',
						borderBottom: '1px solid #ccc',
					}}
				>
					Notificaciones
				</h5>
				{notifications.length > 0 ? (
					<>
						{notifications?.map((e) => (
							<div className="d-flex p-3 border-bottom" key={e.id}>
								<span
									style={{
										fontSize: '12px',
									}}
								>
									Se solicita su aprobacion para eliminar la sesión{' '}
									<strong>{e.numeroSesion}</strong>
									<br />
									Solicitud realizada el dia:{' '}
									<strong>
										{formatDate(
											'EEEE PP, HH:mm',
											new Date(e.fechaSolicitud)
										)}{' '}
										hrs.
									</strong>
									<br />
									Por el usuario:{' '}
									<strong> {e.idMiembroSolicitante} </strong>
									<br />
									<strong
										className={'hover-detail-notfication'}
										onClick={() =>
											history.push(
												`/sesiones/consultar-sesiones/sesion/${e.idSesion}`
											)
										}
									>
										{' '}
										Detalle...{' '}
									</strong>
								</span>

								<div className="d-flex flex-row ">
									<IconButton
										onClick={() =>
											approvalNotification(e, 'aprobacion=true')
										}
										color="primary"
										aria-label="delete"
										style={{ padding: '4px' }}
									>
										<CheckIcon style={{ color: 'green' }} />
									</IconButton>
									<IconButton
										onClick={() =>
											approvalNotification(e, 'cancelacion=true')
										}
										color="primary"
										aria-label="delete"
										style={{ padding: '4px' }}
									>
										<CloseIcon />
									</IconButton>
								</div>
							</div>
						))}
					</>
				) : (
					<div
						style={{
							fontSize: '14px',
							color: '#A1A5B6',
							textAlign: 'center',
							marginTop: '10px',
						}}
					>
						Por el momento no hay notificaciones
					</div>
				)}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default Notifications;
